import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to TimberCraft",
    title: "Exquisite Woodwork {for Every Space}",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to TimberCraft",
    title: "Premium Woodwork Solutions {for Your Home}",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to TimberCraft",
    title: "Custom Woodwork Designs {for Your Space}",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
];

export default home;